import { LicencedIntervenor } from "@/Common/Api/MedfarDictionaries/Dto/Responses/LicencedIntervenor";
import { LicenceOrganisationRule } from "@/Common/Api/MedfarDictionaries/Dto/Responses/LicenceOrganisationRule";
import { LicenceOrganisationSpecialisation } from "@/Common/Api/MedfarDictionaries/Dto/Responses/LicenceOrganisationSpecialisation";
import { GuidHelper } from "@/Common/Helpers/GuidHelper";
import { DirectoryHealthCareProviderMapper } from "@/ContactDirectory/Api/Mapper/DirectoryHealthCareProviderMapper";
import { DirectoryHealthCareProviderSearchDto } from "@/ContactDirectory/Api/medfar-contactdirectory/dist";

class PatientRefIntervenorWithDetails {
    public Intervenor: PatientRefIntervenor;

    public LicencedIntervenor: LicencedIntervenor;
    public HealthCareProvider: DirectoryHealthCareProviderSearchDto;
    public LicenceOrganisationRule: LicenceOrganisationRule;
    public LicenceOrganisationSpecialisation: LicenceOrganisationSpecialisation;

    constructor(init?: Partial<PatientRefIntervenorWithDetails>) {
        this.HealthCareProvider = DirectoryHealthCareProviderMapper.cloneSearchDto(init?.HealthCareProvider);
        this.LicencedIntervenor = init?.LicencedIntervenor ? new LicencedIntervenor(init.LicencedIntervenor, false) : null;
        this.Intervenor = init?.Intervenor ? { ...init.Intervenor } : null;
        this.LicenceOrganisationRule = init?.LicenceOrganisationRule ? new LicenceOrganisationRule({ ...init.LicenceOrganisationRule }) : null;
        this.LicenceOrganisationSpecialisation = init?.LicenceOrganisationSpecialisation ? new LicenceOrganisationSpecialisation({ ...init.LicenceOrganisationSpecialisation }) : null;
    }
}

class PatientRefIntervenor {
    constructor(id?: string, note?: string) {
        this.Id = id ?? GuidHelper.NewGuid(); // Tmp Id until saved
        this.Note = note || "";
    }

    public Id: string;
    public Start: string;
    public End: string;
    public Speciality: string;
    public IntervenorId: string;
    public EmployeeId: string;
    public LicenceOrganisationSpecialisationId: string;
    public LicenceOrganisationRuleId: string;
    public PatientId: string;
    public IsPrimary: boolean;
    public Note: string;

    // Contact Directory Specific
    public HealthCareProviderId?: string;
    public DirectoryFaxNumberId?: string;
}

export { PatientRefIntervenor, PatientRefIntervenorWithDetails };
